import styled from 'styled-components';

export const Container = styled.div`
  min-width: calc(100% - 88px);
  height: calc(100vh - 30px);

  h1 {
    font-size: 26px;
    font-weight: 500;
  }

  hr {
    background: #e1e1e1;
    opacity: 1;
  }

  a {
    :hover {
      color: unset;
    }
  }

  iframe {
    border-radius: 8px;
  }
`;
